/**
 * ComparisonTable - Side-by-side taxonomy vs ontology vs knowledge graph
 *
 * 7-row comparison with detected tier column highlighted.
 */

import React from 'react';
import type { KnowledgeTier } from './types';
import { COMPARISON_DATA, TIER_COLORS } from './types';

interface ComparisonTableProps {
  detectedTier: KnowledgeTier;
}

export const ComparisonTable: React.FC<ComparisonTableProps> = ({ detectedTier }) => {
  const columns: Array<{ key: KnowledgeTier; label: string }> = [
    { key: 'taxonomy', label: 'Taxonomy' },
    { key: 'ontology', label: 'Ontology' },
    { key: 'knowledge_graph', label: 'Knowledge Graph' },
  ];

  const getValue = (row: typeof COMPARISON_DATA[0], tier: KnowledgeTier): string => {
    switch (tier) {
      case 'taxonomy': return row.taxonomy;
      case 'ontology': return row.ontology;
      case 'knowledge_graph': return row.knowledgeGraph;
    }
  };

  return (
    <div className="ka-comparison-table-wrapper">
      <h4 className="ka-section-title">Tier Comparison</h4>
      <div className="ka-comparison-table-scroll">
        <table className="ka-comparison-table">
          <thead>
            <tr>
              <th className="ka-comparison-dimension-header">Dimension</th>
              {columns.map(col => (
                <th
                  key={col.key}
                  className={`ka-comparison-tier-header ${col.key === detectedTier ? 'ka-comparison-detected' : ''}`}
                  style={col.key === detectedTier ? { borderTopColor: TIER_COLORS[detectedTier] } : undefined}
                >
                  {col.label}
                  {col.key === detectedTier && (
                    <span className="ka-comparison-detected-badge">Current</span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COMPARISON_DATA.map(row => (
              <tr key={row.dimension}>
                <td className="ka-comparison-dimension">{row.dimension}</td>
                {columns.map(col => (
                  <td
                    key={col.key}
                    className={`ka-comparison-cell ${col.key === detectedTier ? 'ka-comparison-detected-cell' : ''}`}
                  >
                    {getValue(row, col.key)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
